import { useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { IntakeFormProps } from '@/models/IntakeForm';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';
import { IntakeResponse } from '@/models/IntakeResponse';
import { logError } from '@/utils/errorHandlerUtil';

export default function useIntake() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  async function postIntake(postInfo: IntakeFormProps): Promise<IntakeResponse | null> {
    const postUrl = `${baseUrl}intakes`;

    try {
      const response = await customFetch<IntakeResponse>(postUrl, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
        body: JSON.stringify(postInfo),
      });

      return response;
    } catch (e) {
      logError(`Error posting intake form.`, e);

      return null;
    }
  }

  return { postIntake };
}
